import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { environment } from '@environments/environment';

import { NotesItem } from '@shared/interfaces';
import { CaseContextService } from '@app/core/services/case-context/case-context.service';
import { TenantFacadeService } from '@shared/features/tenant/shared/services/tenant-facade.service';

@Injectable({
  providedIn: 'root',
})
export class NotesApiService {
  private readonly _http = inject(HttpClient);
  private readonly _caseContext = inject(CaseContextService);
  private readonly _tenantFacadeService = inject(TenantFacadeService);

  public addNote(param: NotesItem): Observable<void> {
    const id: number | null = this._caseContext.id();

    return this._http.post<void>(
      `${environment.api}/${this._tenantFacadeService.tenantApiPrefix()}/${id}/notes/`,
      param,
    );
  }
}
